const MOTOR_FIELDS = {
    RESULTADO_CALCULO: 'resultadoCalculo',
    ENTRADA: {
        BENS: 'bens',
        COMISSAO_TOTAL_OPERACAO: 'comissaoTotalOperacao'
    },
    SAIDA: {
        LISTA_COMBOS: 'listaCombos',
        COMISSAO_BB_CORRETORA: 'comissaoBbCorretora',
        COMISSAO_CORRETOR_1: 'comissaoCorretor1',
        COMISSAO_CORRETOR_2: 'comissaoCorretor2',
        COMISSAO_CORRETOR_3: 'comissaoCorretor3',
        COMISSAO_TOTAL: 'comissaoTotalOperacao'
    }
};

export default MOTOR_FIELDS;
